import { Modal } from './Modal.js';
import type { HistoryRow } from '../lib/reviewHistory.js';

/**
 * ehr#682 (PROGRESS-NOTE V141 V86): the Comment history window: every comment action on the note
 * with its words, and the review's steps, newest first. Read only; never printed.
 */
export function CommentHistory({ rows, onClose }: { rows: HistoryRow[]; onClose: () => void }) {
  const when = (iso: string) =>
    new Date(iso).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  return (
    <Modal
      title="Comment history"
      onClose={onClose}
      className="pn-hist-modal"
      actions={
        <button type="button" className="btn" onClick={onClose}>
          Close
        </button>
      }
    >
      <div className="pn-loglist" data-test="comment-history">
        {rows.length === 0 && <p className="pn-ns-muted">Nothing logged yet.</p>}
        {rows.map((r) => (
          <div key={r.key} className="pn-logrow">
            <span className="pn-logwhen">{when(r.at)}</span>
            <span>
              <b>{r.who}</b> {r.what}
            </span>
          </div>
        ))}
      </div>
    </Modal>
  );
}
